<div class="dropdown-container__title dropdown-container__tooltip dropdown-container__subtitle">
  <span>{{(index === 0 ? 'ADDITIONAL_DRIVERS_DATA_SECTION.headerOneAdditionalDriver' : 'ADDITIONAL_DRIVERS_DATA_SECTION.headerNextAdditionalDriver')| translate }}</span>
</div>

<div class="form">

  <app-section-data-presentation *ngIf="previewMode"
                                 [formGroup]="additionalDriverFormGroup"
                                 [parentSection]="parentSection"
                                 [formConfig]="additionalDriverFormConfig"
                                 [displayedFields]="dataPresentationFields">
  </app-section-data-presentation>

  <div class="col" [ngClass]="{'col-preview-mode': previewMode}">

    <div *ngIf="canFieldDisplayed(consts.BIRTH_DATE)"
         class="section__component col-50 datepicker-component">
      <app-material-datepicker [errorsMap]="additionalDriverFormService.errorsMap"
                               [control]="additionalDriverFormGroup.controls[consts.BIRTH_DATE]"
                               [fieldConfig]="additionalDriverFormService.fieldConfig(consts.BIRTH_DATE, additionalDriverFormConfig)"
                               [context]="additionalDriverFormConfig.formKey"
                               [isDirtyBean]="isDirtyBean && isDirtyBean[getAdditionalDriverKeyWithIndex(consts.BIRTH_DATE, index)]"
                               (markAsDirty)="markAsDirty($event)"></app-material-datepicker>
    </div>

    <div *ngIf="canFieldDisplayed(consts.DRIVING_LICENSE_ISSUE_YEAR)" class="section__component col-50">
        <app-material-year-picker #drivingLicenseIssueYearField
                                  [errorsMap]="additionalDriverFormService.errorsMap"
                                  [bean]="bean"
                                  [control]="additionalDriverFormGroup.controls[consts.DRIVING_LICENSE_ISSUE_YEAR]"
                                  [fieldConfig]="additionalDriverFormService.fieldConfig(consts.DRIVING_LICENSE_ISSUE_YEAR, additionalDriverFormConfig)"
                                  [context]="additionalDriverFormConfig.formKey"
                                  [customMetrics]="customMetricsData(index)"
                                  [isDirtyBean]="isDirtyBean && isDirtyBean[getAdditionalDriverKeyWithIndex(consts.DRIVING_LICENSE_ISSUE_YEAR, index)]"
                                  (markAsDirty)="markAsDirty($event)"
        >
        </app-material-year-picker>
    </div>

    <div class="section__component col-50"
                 *ngIf="drivingLicenseIssueMonthCollected && canFieldDisplayed(consts.DRIVING_LICENSE_ISSUE_MONTH)">
            <app-select
                    [errorsMap]="additionalDriverFormService.errorsMap"
                    [control]="additionalDriverFormGroup.controls[consts.DRIVING_LICENSE_ISSUE_MONTH]"
                    [fieldConfig]="additionalDriverFormService.fieldConfig(consts.DRIVING_LICENSE_ISSUE_MONTH, additionalDriverFormConfig)"
                    [context]="additionalDriverFormConfig.formKey"
                    [customMetrics]="customMetricsData(index)"
                    [isDirtyBean]="isDirtyBean && isDirtyBean[getAdditionalDriverKeyWithIndex(consts.DRIVING_LICENSE_ISSUE_MONTH, index)]"
                    (markAsDirty)="markAsDirty($event)"
            >
            </app-select>
        </div>

  </div>

</div>
